import * as React from 'react';

import { Alert } from 'antd';

export default function APIInativationAlert() {
  const today = new Date();
  const inactivationDate = new Date('2026-04-30T23:59:59');

  if (today > inactivationDate) {
    return null;
  }

  return (
    <Alert
      type='warning'
      message='Descontinuaremos esta API em 11/01/2027!'
      description={
        <>
          <p className='mb-1 text-sm'>
            Mas calma: você poderá utilizar a Developer Hub como fonte de estrutura para suas novas integrações, lá você
            encontra:
          </p>
          <p className='mb-1 text-sm'>🔹 APIs mais completas, com novos endpoints</p>
          <p className='mb-1 text-sm'>🔹 Melhor performance e estabilidade</p>
          <p className='mb-1 text-sm'>🔹 Documentação atualizada e centralizada</p>
          <p className='mb-1 text-sm'>🔹 Canal no Discord para desenvolvedores</p>
          <p className='mb-1 text-sm'>
            👉 Para garantir a continuidade da sua integração, recomendamos que atualize sua conexão com antecedência.
          </p>
          <p className='text-sm'>
            <a
              href='https://ajuda.eduzz.com/como-migrar-minhas-integrações-para-a-developer-hub-'
              target='_blank'
              rel='noopener noreferrer'
            >
              🔗 Ver novas APIs no Developer Hub
            </a>
          </p>
        </>
      }
    />
  );
}
